import React from 'react';
import GlobalBlockRenderer from './GlobalBlockRenderer';
import PageBlocksRenderer from './PageBlocksRenderer';
import ProfileCompletionBanner from './ProfileCompletionBanner';

/**
 * RetailerLayout V11 - Layout Global Cohérent avec Design System Unifié
 * 
 * ARCHITECTURE V11 (REFACTOR STRUCTUREL MAI 2026) :
 * 
 * DESIGN SYSTEM UNIFIÉ:
 * - Référence largeur: max-w-7xl (1280px)
 * - Header + Menu + Footer: utilisent max-w-7xl mx-auto px-4
 * - Content: les blocs CMS utilisent CmsBlocksRenderer (1280px)
 * 
 * STRUCTURE:
 * ✅ Header : Bloc global via GlobalBlockRenderer (sticky top-0, centré max-w-7xl)
 * ✅ Menu : Bloc global via GlobalBlockRenderer (sticky top-16, centré max-w-7xl)
 * ✅ Content : 
 *    - SI children fourni → affiche children (pages avec leur propre layout)
 *    - SINON → PageBlocksRenderer (pages dynamiques CMS)
 * ✅ Footer : Bloc global via GlobalBlockRenderer (centré max-w-7xl)
 * 
 * COMPORTEMENT ZOOM:
 * - Menu centré à tous les niveaux de zoom (67% - 150%)
 * - Pas de décalage horizontal
 * - Stable sur toutes résolutions (1366px à ultrawide)
 */
const RetailerLayout = ({ children }) => {
  // Déterminer si on doit afficher children ou les blocs dynamiques
  const hasChildren = React.Children.count(children) > 0;
  
  return (
    <div className="min-h-screen flex flex-col">
      {/* ZONE STICKY : HEADER */}
      <div className="sticky top-0 z-50 w-full bg-white">
        <GlobalBlockRenderer type="header" />
      </div>
      
      {/* ZONE STICKY : MENU */}
      <div className="sticky top-16 z-40 w-full bg-white">
        <GlobalBlockRenderer type="menu" />
      </div>
      
      {/* BANNIÈRE PROFIL INCOMPLET */}
      <ProfileCompletionBanner />
      
      {/* CANVAS RETAILER : #F7F5F2 */}
      <main className="flex-1 w-full bg-[#F7F5F2]">
        {hasChildren ? (
          // Les pages enfants (HubPage, etc.) gèrent leur propre container via CmsBlocksRenderer
          // NE PAS appliquer de max-width ici pour éviter le double container
          <>{children}</>
        ) : (
          <PageBlocksRenderer 
            position="content"
            debug={false}
          />
        )}
      </main>
      
      {/* FOOTER */}
      <div className="w-full mt-auto">
        <GlobalBlockRenderer type="footer" />
      </div>
    </div>
  );
};

export default RetailerLayout;
